import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PageHeader from '../../components/layout/content/header/PageHeader';
import PageHeaderAction from '../../components/layout/content/header/PageHeaderAction';
import SearchForm from '../../components/others/search-form/SearchForm';
import SearchFormField from '../../components/others/search-form/SearchFormField';
import icons from '../../icons';
import { DEFAULT_ROWS_PER_PAGE } from '../../root-constants';
import { useAuthState } from '../../state/auth';
import { TitleContext } from '../../state/title';
import { useAPI } from '../../utils/hooks/api.hooks';
import BookingRequestsTable from './booking-requests-table/BookingRequestsTable';

interface BookingRequestsArchivePageProps {}

const BookingRequestsArchivePage: React.FC<BookingRequestsArchivePageProps> = () => {
  // const classes = useStyles();
  //   const { lang, txc } = useIntl();

  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(DEFAULT_ROWS_PER_PAGE);

  const { user } = useAuthState();

  const history = useHistory();

  const [, setTitle] = useContext(TitleContext);

  useEffect(() => {
    setTitle('');
  }, [setTitle]);

  const { data, loading } = useAPI('bookingRequests/list', {
    pagination: { page, results: rowsPerPage },
    count: true,
    archived: true,
  });

  const bookingRequest = data?.items ?? [];
  const count = data?.count ?? 0;

  return (
    <>
      <PageHeader title="Archive" subtitle={'Booking Requests > Archive'}>
        <PageHeaderAction
          label={'Back to Booking Requests'}
          action={() => history.push('/booking-requests')}
          icon={icons.bookings}
        />
      </PageHeader>

      <SearchForm columns={4}>
        <SearchFormField placeholder="Cerca per proprietá" onChange={() => {}} />
        <SearchFormField placeholder="Cerca per proprietá" onChange={() => {}} />
        <SearchFormField placeholder="Cerca per proprietá" onChange={() => {}} />
        <SearchFormField placeholder="Cerca per proprietá" onChange={() => {}} />
      </SearchForm>

      <BookingRequestsTable
        bookingRequests={bookingRequest}
        count={count}
        handleChangePage={setPage}
        page={page}
        loading={loading}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        archive={true}
      />
    </>
  );
};

// const useStyles = makeStyles((theme: Theme) => ({}));

export default BookingRequestsArchivePage;
